<template>
  <v-container fluid class="payroll-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            v-if="initvalue.payrollstatus!=='Complete'" 
            :href="`#tab-payroll`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document-multiple</v-icon>
            Payroll
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item
            v-if="initvalue.payrollstatus!=='Complete'" 
            :value="'tab-payroll'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Payroll</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'payrollname')"
                        v-bind:value="initvalue.payrollname"
                        placeholder="Payroll Name"
                        persistent-hint
                        single-line hint="Enter the payroll name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=payrollstatus
                        :value="initvalue.payrollstatus"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'payrollstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the payroll status">
                      </v-select>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/payroll/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPayroll()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Files</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="filedialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="fileHeaders"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deletefiledialog" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ deletefile.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deletefiledialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(deletefile)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                          <a
                            v-if="item.filetype == 'pdf'"
                            :href="item.fileurl"
                            style="text-decoration: none !important"
                          >
                            <v-icon size="50" color="primary">
                              mdi-file-pdf-box
                            </v-icon></a
                          >
                        </template>
                        <template v-slot:item.filesize="{ item }">
                          {{ (item.filesize / 1000).toFixed(0) + " KB" }}
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/payroll/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
        <v-dialog v-model="filedialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Upload File</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-file-input
                      label="File input"
                      v-on:change="onUploadFileChange"
                      accept=".pdf"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="upload.filename"
                      label="File Name"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="
                  filedialog = false;
                  upload.file = null;
                  upload.filename = '';
                "
              >
                Close
              </v-btn>
              <v-btn
                :disabled="upload.file == null || upload.filename==null || upload.filename.length < 2"
                color="blue darken-1"
                text
                @click="uploadFile"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      payroll: {},
      deletefile: {},
      upload: {
        filename: null,
        file: null,
      },
      filedialog: false,
      deletefiledialog: false,
      payrollstatus: ['New', 'Pending', 'Complete'],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      files: [],
      initvalue: {},
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Payroll', ['updatePayrollRequest','getPayrollsRequest']),
    ...mapActions("File", ["insertPayrollFile", "deleteFileRequest", "getPayrollFiles"]),
    async editPayroll() {
      this.payroll._id = this.initvalue._id;
      this.updatePayrollRequest(this.payroll);
      this.getPayrollsRequest();
      router.push('/payroll/list');
    },
    async deleteFile(payload) {
      this.deletefiledialog = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    deleteFileDialog(item) {
      this.deletefiledialog = true;
      this.deletefile = {
        _id: item._id,
        filename: item.filename,
      };
      console.log(this.deletefile);
    },
    onUploadFileChange(file) {
      console.log(file)
      if (file==null) this.uploadfile = null;
      else this.upload.file = file;
      
      console.log("0", this.upload)
    },
    updateChangedValue(value, field){
      this.payroll[field] = value;
    },
    async uploadFile(){
      this.upload.payrollid = this.initvalue._id;
      this.filedialog = false;

      let file = await this.insertPayrollFile(this.upload);
      this.files.push(file);
    },
  },
  computed: {
    ...mapState('Payroll', ['isReceiving'])
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'PayrollList' });
    this.files = await this.getPayrollFiles(this.initvalue._id);
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
